module.exports = {
  Utils: {
    ...require('./src/Utils'),
    ...require('./src/shims/Browser'),
  },
  EventEmitter: require('./src/EventEmitter'),
};
